<template>
  <blockquote class="relative ml-10">
    <p class="text-xl">
      <span class="font-serif text-6xl absolute -ml-10 -mt-6 text-kwlightgray">“</span>
      {{ quote }}
    </p>
    <p class="text-kwred text-2xl my-2">★★★★★</p>
    <footer class="text-kwdarkgray italic">—
      <component :is="href?'a':'span'" :href="href" >{{ name }}</component>
    </footer>
  </blockquote>
</template>

<script>
export default {
  name: 'Testimonial',
  props: {
    quote: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: false
    }
  }
}
</script>
